import { render } from "./physiothMainten.vue?vue&type=template&id=528924d6&scoped=true"
import script from "./physiothMainten.vue?vue&type=script&lang=js"
export * from "./physiothMainten.vue?vue&type=script&lang=js"

import "./physiothMainten.vue?vue&type=style&index=0&id=528924d6&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528924d6"]])

export default __exports__